import { createContext, useState } from 'react';

const PageContext = createContext();

const PageProvider = (props) => {
    const [filters, setFilters] = useState({
        open: false,
        sort: 'namea-z',
        search: '',
    });

    const resetFilters = () => {
        setFilters((current) => ({
            ...current,
            sort: 'namea-z',
        }));
    };

    return (
        <PageContext.Provider
            value={{
                filters,
                setFilters,
                resetFilters,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
